import React from 'react';
import { useTranslation } from 'react-i18next';

const ProcessSection = () => {
  const { t } = useTranslation('latvia');

  const steps = [
    {
      number: '01',
      title: t('process.step1.title'),
      description: t('process.step1.desc'),
      icon: 'ri-user-search-line',
    },
    {
      number: '02',
      title: t('process.step2.title'),
      description: t('process.step2.desc'),
      icon: 'ri-file-list-3-line',
    },
    {
      number: '03',
      title: t('process.step3.title'),
      description: t('process.step3.desc'),
      icon: 'ri-file-text-line',
    },
    {
      number: '04',
      title: t('process.step4.title'),
      description: t('process.step4.desc'),
      icon: 'ri-send-plane-line',
    },
    {
      number: '05',
      title: t('process.step5.title'),
      description: t('process.step5.desc'),
      icon: 'ri-chat-check-line',
    },
    {
      number: '06',
      title: t('process.step6.title'),
      description: t('process.step6.desc'),
      icon: 'ri-award-line',
    },
  ];

  return (
    <section className="py-6 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-5xl font-bold text-gray-900 mb-3 md:mb-4 font-serif">
            {t('process.title')}
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto">
            {t('process.description')}
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-gold-200 via-gold-400 to-gold-200 transform -translate-y-1/2"></div>

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-xl p-4 md:p-6 shadow-lg border-2 border-gray-100 hover:border-gold-400 transition-all duration-300 h-full">
                  <div className="flex items-center md:items-start mb-2 md:mb-4">
                    <div className="w-9 h-9 md:w-14 md:h-14 flex items-center justify-center bg-gradient-to-br from-gold-400 to-gold-600 rounded-lg md:rounded-xl mr-2 md:mr-4 flex-shrink-0">
                      <i className={`${step.icon} text-base md:text-2xl text-white`}></i>
                    </div>
                    <div className="text-2xl md:text-5xl font-bold text-gold-200 font-serif">{step.number}</div>
                  </div>
                  <h3 className="text-xs sm:text-sm md:text-xl font-bold text-gray-900 mb-1 md:mb-3">{step.title}</h3>
                  <p className="text-gray-600 text-[10px] sm:text-xs md:text-sm leading-relaxed hidden sm:block">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 md:mt-12 text-center">
          <div className="inline-flex items-center px-4 md:px-6 py-2.5 md:py-3 bg-gold-50 rounded-full border border-gold-200">
            <i className="ri-time-line text-gold-600 text-base md:text-xl mr-2 md:mr-3"></i>
            <span className="text-gray-700 font-medium text-xs md:text-base">
              <strong className="text-gold-600">{t('process.note')}</strong> {t('process.noteTime')}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;